import axios from "axios";

export const registrarBitacoraTramite = async (
  idTramite,
  observacion,
  tipo
) => {
  try {
    const datoBitacoraTra = {
      idTramite: idTramite,
      idUsuario: window.sessionStorage.getItem("idUsuario"),
      tipo: tipo,
      observacion: observacion,
    };
    await axios.post(
      "http://localhost:8080/api/v1/bitacoratras",
      datoBitacoraTra
    );
  } catch (error) {
    console.error("Error al registrar en bitácora:", error);
  }
};
